import { render } from "./KycFinishedPage.vue?vue&type=template&id=2ed8d6a6"
import script from "./KycFinishedPage.vue?vue&type=script&lang=js"
export * from "./KycFinishedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__